module.exports = __webpack_public_path__ + "static/media/bottomNew.ffeb8105.png";